import { conf } from './conf.js';
import { reusable } from './convincely.js';
import { createSessionStorage, createStorage, DataStorage } from './storage.js';
export const input = reusable('input', createStorage(conf.storageKey, undefined, undefined, conf.useCookies), conf.$appName);
export const inputSensitive = new DataStorage();
export const inputSession = reusable('inputSession', createSessionStorage(`s${conf.storageKey}`), conf.$appName);
export { input as coreInput };
//# sourceMappingURL=input.js.map